import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/jsonMessages';
import { headerTextStyle, mailBody, mailHeaderLogo, tableLayoutStyle } from '../../../helpers/getEmailTemplateStyles';
import EmailSignature from '../../../core/email/template/EmailSignature';
import Footer from '../../../core/email/modules/Footer';
import { convertQuillToEmailHtml } from '../../../helpers/emailQuillHelper';
import bt from '../../../components/commonStyle.css';

function EmailPreview({ subject, previewText, bodyHtml, type, logoUrl, siteName }) {
  const intl = useIntl();
  /* Dynamic preview: body shows placeholders as-is; header/signature/footer show Site Settings siteName when available */
  const displaySiteName = siteName && siteName.trim() !== '' ? siteName : '{{siteName}}';
  const [documentVerificationTab, setDocumentVerificationTab] = useState('approved');


  return (
    <div>
      <div className={cx(bt.commonContentText, bt.spaceBottom1, bt.fontWeightBold)}>{subject || intl.formatMessage(messages.emailTemplateNoSubject)}</div>
      {previewText ? <div className={cx(bt.commonSmallText, bt.spaceBottom3)}>{previewText}</div> : null}
      <div style={tableLayoutStyle}>
        <div style={headerTextStyle}>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={displaySiteName}
              style={mailHeaderLogo}
            />
          ) : <div>{displaySiteName}</div>
          }
        </div>
        <div style={mailBody}>
          <div dangerouslySetInnerHTML={{ __html: convertQuillToEmailHtml(bodyHtml) }} />
          <div style={{ height: 30 }} />
          <EmailSignature siteName={displaySiteName} />
        </div>
        <Footer siteName={displaySiteName} />
      </div>
    </div>
  );
}

EmailPreview.propTypes = {
  subject: PropTypes.string,
  previewText: PropTypes.string,
  bodyHtml: PropTypes.string,
  type: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  siteName: PropTypes.string,
};

EmailPreview.defaultProps = {
  subject: '',
  previewText: '',
  bodyHtml: '',
  logoUrl: '',
  siteName: '',
};

export default withStyles(bt)(EmailPreview);
